import React, { SVGProps } from 'react';

const SvgSort2 = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					d='M5.5 6A1.5 1.5 0 017 7.5v11a1.5 1.5 0 01-3 0v-11A1.5 1.5 0 015.5 6zm6 5a1.5 1.5 0 011.5 1.5v6a1.5 1.5 0 01-3 0v-6a1.5 1.5 0 011.5-1.5zm6 4a1.5 1.5 0 011.5 1.5v2a1.5 1.5 0 01-3 0v-2a1.5 1.5 0 011.5-1.5z'
					fill='currentColor'
				/>
			</g>
		</svg>
	);
};

export default SvgSort2;
